"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const PublicPrivacyNoticeModalContentUtil_1 = require("./PublicPrivacyNoticeModalContentUtil");
const StoresUtil_1 = require("../../../util/StoresUtil");
let DataProcessingLegalContent = class DataProcessingLegalContent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get dataProcessingRows() {
        const { translate } = this.translateStore;
        return [
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow1'),
                type: translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow2'),
                type: translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow3'),
                type: translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow4'),
                type: translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow5'),
                type: translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow6'),
                type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow7'),
                type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow8'),
                type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow9'),
                type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow10'),
                type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
            },
            {
                content: translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.tablerow11'),
                type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
            }
        ];
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(lib_1.Text, null,
            react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.data.processing.legal.content.text1')),
            react_1.default.createElement(PublicPrivacyNoticeModalContentUtil_1.DataProcessingTable, { data: this.dataProcessingRows })));
    }
};
DataProcessingLegalContent = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], DataProcessingLegalContent);
exports.default = DataProcessingLegalContent;
